module.exports = __webpack_public_path__ + "img/visa-mastercard-logo.1adc6383.png";